<div style="overflow-y: hidden; overflow-x: hidden;">
    <form [formGroup]="updatePasswordForm">
        <div class="grid">
            <div class="col-12 md:col-6 lg:col-6">
                <div class="mt-2">
                    <label for="" class="required-field">New Password: </label>
                    <div>
                        <p-password formControlName="newPassword" [feedback]="false"></p-password>
                    </div>
                </div>
                <div class="mt-3">
                    <label for="" class="required-field">Confirm New Password: </label>
                    <div>
                        <p-password formControlName="confirmPassword" [feedback]="false"></p-password>
                    </div>
                    <span class="msg-style" [ngStyle]="{'color': passwordsMatch ? '#A00214' : '#509E2F' }">{{showMessage}}</span>
                </div>
                <div  class="mt-3">
                    <button pButton type="button" label="Reset Password" class="btnClass" (click)="resetPassword()" [disabled]="update()"></button>
                </div>
            </div>
            <div class="col-12 md:col-6 lg:col-6">
                    <p class="font-bold ml-3">Password must contain : </p>
                    <ul class="" style="line-height: 1.5">
                        <li [ngClass]="{'color': hasLowerCasePassed}">At least one lowercase</li>
                        <li [ngClass]="{'color': hasUpperCasePassed}">At least one uppercase</li>
                        <li [ngClass]="{'color': hasNumberPassed}">At least one numeric</li>
                        <li [ngClass]="{'color': hasSpecialCharactersPassed}">At least one special character</li>
                        <li [ngClass]="{'color' : stringLengthPassed}">Minimum 10 characters</li>
                    </ul>
            </div>
        </div>
        
            <div class="flex flex-wrap">
                <div class="flex align-items-center justify-content-center m-2"><i class="pi pi-exclamation-triangle" style="color: orange;"></i></div>
                <div class="flex align-items-center justify-content-center m-1 menu-item-text">Only change password in coordination with this Partner</div>
            </div>
    </form>
</div>